import React from 'react'
import { Image } from '@shared/components/image'
import cx from 'classnames'

import { journalPoints } from './data'

import styles from './style.module.scss'

export const View = () => (
	<>
		<div className={styles.content}>
			<div className={styles.summary}>
				<h2 className={styles.title}>Популярно рассказываем о кредитовании под залог</h2>
				<p className={styles.summaryContent}>
					Наша цель — помочь людям не потерять свои деньги из-за кредитных рисков. Для этого мы
					пишем статьи и снимаем видео, в которых эксперты рассказывают о том, как избежать штрафов,
					скрытых условий и уловок мошенников.
				</p>
			</div>
			<div className={styles.links}>
				{journalPoints.map(({ href, imageUrl, content }, i) => (
					<a
						className={cx(styles.link, 'main-link')}
						key={`journal-link-${i}`}
						href={href}
						target='_blank'
						rel='noopener noreferrer nofollow'
					>
						<div className={styles.img}>
							<Image name={imageUrl} lazy />
						</div>
						<h3 className={styles.journalTitle}>{content}</h3>
					</a>
				))}
			</div>
		</div>
	</>
)
